import script from "./app-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-header.vue?vue&type=script&setup=true&lang=ts"

import "./app-header.vue?vue&type=style&index=0&id=7be374c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be374c4"]])

export default __exports__